import React from 'react';
import { motion } from 'framer-motion';
import { PlayCircle, ThumbsUp } from 'lucide-react';

const VIDEO_ID = 'Yw4QWGmbifo';
const VIDEO_TITLE = 'MonAlerte : Le bouclier numérique qui réinvente la sécurité citoyenne';
const VIDEO_WATCH_URL = `https://youtu.be/${VIDEO_ID}`;

const ProjectVideo = () => {
  return (
    <section
      className="section-padding"
      style={{
        background: 'linear-gradient(180deg, #081222 0%, #050b14 100%)',
        position: 'relative'
      }}
    >
      <div style={{ maxWidth: '900px', margin: '0 auto' }}>
        <div className="text-center" style={{ marginBottom: '40px' }}>
          <span className="badge-gold">
            <PlayCircle size={16} color="var(--mga-gold)" />
            Présentation en vidéo
          </span>
          <h2 style={{
            fontSize: 'clamp(1.8rem, 3.5vw, 2.4rem)',
            color: 'var(--mga-white)',
            marginTop: '10px'
          }}>
            Découvrez MonAlerte <span style={{ color: 'var(--mga-gold)' }}>en 7 minutes</span>
          </h2>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-80px' }}
          transition={{ duration: 0.7 }}
          className="glass-card"
          style={{
            padding: '12px',
            border: '1px solid rgba(242, 184, 7, 0.2)'
          }}
        >
          <div style={{
            position: 'relative',
            width: '100%',
            aspectRatio: '16 / 9',
            borderRadius: '14px',
            overflow: 'hidden',
            backgroundColor: '#000'
          }}>
            <iframe
              src={`https://www.youtube-nocookie.com/embed/${VIDEO_ID}?cc_load_policy=0`}
              title={VIDEO_TITLE}
              // Le site est en no-referrer ; YouTube refuse les intégrations sans origine.
              referrerPolicy="strict-origin-when-cross-origin"
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                border: 0
              }}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
              loading="lazy"
            />
          </div>

          <div style={{ display: 'flex', justifyContent: 'center', marginTop: '16px' }}>
            <a
              href={VIDEO_WATCH_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="button-secondary"
              style={{ fontSize: '0.9rem', padding: '10px 22px' }}
            >
              <ThumbsUp size={16} />
              <span>J'aime cette vidéo sur YouTube</span>
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default ProjectVideo;
